/**
 * Centralised environment access (mirrors the skeleton's config/environment.ts,
 * trimmed to what the Rides portal needs).
 */
export const ENV = {
  CLIENT_SECRET: (import.meta.env.VITE_CLIENT_SECRET as string) || 'dev-secret-key',
  APP_VERSION: (import.meta.env.VITE_APP_VERSION as string) || '0.1.0',

  // Firebase Cloud Messaging (web push) — all PUBLIC client config.
  FIREBASE_API_KEY: import.meta.env.VITE_FIREBASE_API_KEY as string | undefined,
  FIREBASE_AUTH_DOMAIN: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string | undefined,
  FIREBASE_PROJECT_ID: import.meta.env.VITE_FIREBASE_PROJECT_ID as string | undefined,
  FIREBASE_MESSAGING_SENDER_ID: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID as string | undefined,
  FIREBASE_APP_ID: import.meta.env.VITE_FIREBASE_APP_ID as string | undefined,
  FIREBASE_VAPID_KEY: import.meta.env.VITE_FIREBASE_VAPID_KEY as string | undefined,
};

export const isDev = () => import.meta.env.DEV;
export const isProd = () => import.meta.env.PROD;
